import styled from 'styled-components/macro';
import Breakpoints from '../../../../themes/constants/breakpoints';

export const ArticlesSliderMainWrap = styled.div`
    width: 100%;
    & .swiper-container {
        position: relative;
        width: 100%;
        padding-bottom: 24px;
        overflow: unset;
    }
    & .swiper-scrollbar {
        width: 100%;
        height: 2px;
        left: 0;
        right: ${({ theme }) => theme.paddings.inner.mobile.paddingRight};
        bottom: 0;
        background: ${({ theme }) => theme.palette.greyLight};
    }
    & .swiper-slide {
        width: auto;
        display: flex;
        justify-content: center;
        align-items: stretch;
        //&:nth-child(2n+1) {
        //    // Fix bug in Swiper after resize...
        //    margin-top: 0 !important;
        //}
    }
    & .swiper-scrollbar-drag {
        background: ${({ theme }) => theme.palette.secondary};
    }
    & .swiper-wrapper {
        flex-flow: column wrap;
        height: 260px;
    }
    @media only screen and (${Breakpoints.TABLET}) {
        width: auto;
        margin: ${({ theme }) => `0 -${theme.paddings.inner.tablet.paddingLeft}`};
        & .swiper-container {
            width: 100%;
            ${({ theme }) => theme.paddings.inner.tablet};
        }
        & .swiper-wrapper {
            height: 330px;
        }
        & .swiper-slide {
            // Fix bug in Swiper after resize...
            margin-top: 0 !important;
            width: auto;
        }
        & .swiper-scrollbar {
            width: 100%;
            max-width: ${({ theme }) => `calc(100% - 2 * ${theme.paddings.inner.tablet.paddingLeft})`};
            left: ${({ theme }) => theme.paddings.inner.tablet.paddingLeft};
            right: ${({ theme }) => theme.paddings.inner.tablet.paddingRight};
        }
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        & .swiper-container {
            padding: 0 20px 0 40px;
        }
        & .swiper-slide {
            // Fix bug in Swiper after resize...
            height: 330px;
        }
        & .swiper-wrapper {
            flex-flow: row wrap;
            height: 708px;
        }
        & .swiper-scrollbar {
            width: 100%;
            max-width: 540px;
            left: 50%;
            right: unset;
            transform: translateX(-50%);
        }
    }
`;
